export var unitToNumber = function unitToNumber(unit) {
  return unit ? parseInt(unit, 10) : 0;
};